import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withHandlers } from 'recompose';
import Form from './Form';
import SimpleHeader from '../../main/headers/simpleHeader';
import { addBrandItem } from './actions';
import * as shapes from '../shapes';
import { trimFunction } from '../../common/trimData';
import { getShopBrandId, isBrandViewActive } from '../../auth/selectors';

const Add = ({ onSubmit, baseUrl }) => (
  <div>
    <SimpleHeader heading="Add brand" />
    <Form onSubmit={trimFunction(onSubmit)} baseUrl={baseUrl} />
  </div>
);
Add.propTypes = {
  onSubmit: shapes.handler.isRequired,
  baseUrl: shapes.url.isRequired,
};

const getBaseUrl = (isBarber, isBrand) => {
  if (isBrand) {
    return '/brand/products/brands';
  }

  if (isBarber) {
    return '/barber/products/brands';
  }

  return '/products/brands';
};

const mapStateToProps = state => ({
  baseUrl: getBaseUrl(state.auth.barberUser, isBrandViewActive(state)),
  brandId: getShopBrandId(state),
});

export default compose(
  withRouter,
  connect(mapStateToProps, { addBrandItem }),
  withHandlers({
    onSubmit: props => values => props.addBrandItem(props.brandId, values),
  }),
)(Add);
